import React from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Input,
  Form,
  Row,
  Col,
  Button
} from 'reactstrap';
import DatePicker from 'components/Inputs/DatePicker';
import { toast } from 'react-toastify';

const SchedulingModal = ({ isOpen, toggle, date, hour, setDate, setHour }) => {
  const handleSave = () => {
    if (!date && !hour) {
      toggle();
      return;
    }

    if (!date || !hour) {
      toast.error(
        'Preencha data e hora para agendar, ou limpe ambos para envio imediato.',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
      return;
    }

    const [day, month, year] = date.split('/');
    const [hourStr, minuteStr] = hour.split(':');

    const fullDate = new Date(
      `${year}-${month}-${day}T${hourStr.padStart(2, '0')}:${minuteStr.padStart(
        2,
        '0'
      )}`
    );

    const now = new Date();

    if (fullDate < now) {
      toast.error('A data e hora não podem ser anteriores ao momento atual.', {
        autoClose: 3000,
        closeOnClick: true
      });
      return;
    }

    toggle();
  };

  const handleClear = () => {
    setDate('');
    setHour('');
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="sm" centered>
      <ModalHeader toggle={toggle}>Agendar envio do e-mail</ModalHeader>
      <ModalBody>
        <Form>
          <Row className="mb-3">
            <Col md="12">
              <label>Data</label>
              <DatePicker
                fieldName="scheduled_date"
                defaultValue={date}
                valueController={(field, value) => setDate(value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <label>Hora</label>
              <Input
                type="time"
                step="60"
                value={hour}
                onChange={(e) => {
                  const [h, m] = e.target.value.split(':');
                  setHour(`${h}:${m}`);
                }}
              />
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClear}>
          Limpar
        </Button>
        <Button color="primary" onClick={handleSave}>
          Salvar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SchedulingModal;
